import ApiService from '../api'

class FundingService {
  async getAll() {
    const result = await ApiService.get('/fundings')
    console.log('Raw response from ApiService.get:', result)
    return result?.Data?.data || []
  }


  async getPublic() {
    const result = await ApiService.get('/fundings/public')
    return result?.Data?.data || []
  }

  async create(payload) {
    // 👇 Fix: pass payload as 3rd argument
    const result = await ApiService.post('/fundings', {}, payload)
    return result?.Data || result
  }

  async update(id, payload) {
    // 👇 Fix: same here
    const result = await ApiService.put(`/fundings/${id}`, {}, payload)
    return result?.Data || result
  }

  async delete(id) {
    const result = await ApiService.delete(`/fundings/${id}`)
    return result?.Data || result
  }
}

export default new FundingService()
